/** MUI */
import { ListItemIcon, MenuItem, MenuList, Popover, alpha } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
/** - icons */
import { Add, Remove } from "@mui/icons-material";

/** Helpers */
import uniq from "lodash/uniq";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: 9998,
    },
    paper: {
        ...theme.shape.boxedWrapper,
        padding: theme.spacing(0),
        minWidth: 260,
        boxShadow: "8px 8px 16px 0px rgba(0,0,0,0.1)",
    },
    itemRoot: {
        fontSize: "0.88888889rem",
        padding: theme.spacing(0.75, 1),
        "&.Mui-focusVisible": {
            backgroundColor: alpha(theme.palette.primary.main, 0.0),
            "&, & svg": {
                color: theme.palette.primary.main,
            },
            outlineColor: theme.palette.primary.main,
        },
    },
    iconBtn: {
        marginTop: -3,
        marginLeft: 0,

        padding: theme.spacing(0.25, 0.25),
        marginRight: -8,
        "&:focus-visible": {
            outlineStyle: "solid",
            outlineColor: theme.palette.primary.main,
        },
    },
}));

const MultiSelect = (props) => {
    const { item, selected, onSelectIndicators, onClose, anchorEl } = props;
    const _selectedByItem = selected?.filter((s) => s.includes(item.id));
    const _childrenIds = item?.children?.map((c) => c.id);

    const classes = useStyles();
    const { t } = useTranslation();

    /** Handlers */
    const handleHide = (event) => {
        onClose && onClose(null);
    };

    const handleSelectAll = (event) => {
        const _newSelected = uniq([...selected, ..._childrenIds])?.toSorted();
        onSelectIndicators && onSelectIndicators(event, _newSelected);
        handleHide();
    };

    const handleUnselectAll = (event) => {
        const _newSelected = selected?.filter((s) => !_childrenIds?.includes(s))?.toSorted();
        onSelectIndicators && onSelectIndicators(event, _newSelected);
        handleHide();
    };

    const open = Boolean(anchorEl);
    const id = open ? "bd-tree-mulri-select-popover" : undefined;

    return (
        <>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleHide}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                TransitionProps={{
                    timeout: {
                        enter: 300,
                        exit: 50,
                    },
                }}
                classes={{ root: classes.root, paper: classes.paper }}
            >
                <MenuList autoFocusItem={open} sx={{ mx: 1, my: 1 }}>
                    <MenuItem
                        onClick={handleSelectAll}
                        classes={{ root: classes.itemRoot }}
                        disabled={_selectedByItem?.length === _childrenIds?.length}
                    >
                        <ListItemIcon>
                            <Add fontSize={"small"} />
                        </ListItemIcon>
                        {t("Zaznacz wszystko")}
                    </MenuItem>
                    <MenuItem
                        onClick={handleUnselectAll}
                        classes={{ root: classes.itemRoot }}
                        disabled={!_selectedByItem?.length}
                    >
                        <ListItemIcon>
                            <Remove fontSize={"small"} />
                        </ListItemIcon>
                        {t("Odznacz wszystko")}
                    </MenuItem>
                </MenuList>
            </Popover>
        </>
    );
};

export default MultiSelect;
